import React from "react";
import { GridLoader } from "react-spinners";

export function Loader() {
  const slogans = [
    "Lets Build Your Digital Presence",
    "Lets Make your idea reality",
  ];
  return (
    <div className="loader">
      <GridLoader color="black" />
    </div>
  );
}
